export default __webpack_public_path__ + "static/media/playStore.0e55452a.png";